import { TableModel, ITableColumn, AggregrationType, TableRow } from 'app/components/table/table.model';
import { Table } from 'app/components/table/table';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import React, { useMemo, useEffect, useState } from 'react';
import { AgtAdzeEmpfehlungItemVM, AgtAdzeEmpfehlungVM } from 'app/stores/ui/agt.adzempfehlung.ui.store';
import _ from 'lodash';


interface IAdzEmpfehlung {
	year: number
}

export const AdzEmpfehlungPivotGs = observer((props: IAdzEmpfehlung) => {
	const { agtAdzEmpfehlungUiStore, anwendungenUiStore, agenturListUiStore, session } = useStore();
	const [loaded, setLoadad] = useState<boolean>(false);
	const tm = new TableModel<AgtAdzeEmpfehlungItemVM, number>();
	const cols: ITableColumn<AgtAdzeEmpfehlungItemVM, number>[] = [
		{
			label: 'gs',
			path: 'agt.gsId',
		},
	];
	const aggCol = {
		label: 'value',
		path: 'value',
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	};

	const pivotCol = {
		label: '',
		path: 'def.label',
	};

	tm.sortBy = 'agt.name';
	tm.setCols(cols);
	tm.idProperty = 'agtId';
	tm.idType = 'number';

	useEffect(() => {
		agtAdzEmpfehlungUiStore.findByYear(props.year).then((res) => {
			res = agenturListUiStore.applyFilterOnAgt(res) as AgtAdzeEmpfehlungVM[];
			let items: AgtAdzeEmpfehlungItemVM[] = [];
			res.forEach((vm) => {
				items.push(...vm.byEmpfehlung);
			});

			tm.setPivotData(items, (x) => x.agt.gsId, aggCol, pivotCol);
			setLoadad(true);
		});
	}, [tm, setLoadad, agtAdzEmpfehlungUiStore, anwendungenUiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore]);

	return (
		<>
			{loaded && (
				<>
					<Table stickyFooter={true} tm={tm} />
				</>
			)}
		</>
	);
});


export const AdzEmpfehlungPivotVD = observer((props: IAdzEmpfehlung) => {
	const { agtAdzEmpfehlungUiStore, anwendungenUiStore, agenturListUiStore, session } = useStore();
	const [loaded, setLoadad] = useState<boolean>(false);
	const tm = new TableModel<AgtAdzeEmpfehlungItemVM, number>();
	const cols: ITableColumn<AgtAdzeEmpfehlungItemVM, number>[] = [
		{
			label: 'gs',
			path: 'agt.vdId',
		},
	];
	const aggCol = {
		label: 'value',
		path: 'value',
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	};

	const pivotCol = {
		label: '',
		path: 'def.label',
	};

	tm.sortBy = 'agt.name';
	tm.setCols(cols);
	tm.idProperty = 'agtId';
	tm.idType = 'number';

	useEffect(() => {
		agtAdzEmpfehlungUiStore.findByYear(props.year).then((res) => {
			res = agenturListUiStore.applyFilterOnAgt(res) as AgtAdzeEmpfehlungVM[];
			let items: AgtAdzeEmpfehlungItemVM[] = [];
			res.forEach((vm) => {
				items.push(...vm.byEmpfehlung);
			});

			tm.setPivotData(items, (x) => x.agt.vdId, aggCol, pivotCol);
			setLoadad(true);
		});
	}, [tm, setLoadad, agtAdzEmpfehlungUiStore, anwendungenUiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore]);

	return (
		<>
			{loaded && (
				<>
					<Table stickyFooter={true} tm={tm} />
				</>
			)}
		</>
	);
});
